import { defaultModelLabel } from '../../../models/model-labels';

/**
 * Build the assistant-text rewriter: rewrite recognized model-id mentions
 * to the native friendly name the picker shows. Handles both the new
 * `provider/company/model/version` format and legacy `provider.model` ids.
 */
export function makeModelMentionRewriter(): (content: string) => string {
  return (content) =>
    content.replace(
      // Match slash-separated ids (provider/company/model/version) or
      // legacy dot-separated ids (provider.model-name).
      /[A-Za-z0-9](?:[\w.:/-]*[A-Za-z0-9])?/gu,
      (token) => {
        const label = defaultModelLabel(token);
        return label.length > 0 && label !== token ? label : token;
      },
    );
}
